export default __webpack_public_path__ + "static/media/RS.7965eb60.png";